import { getProductDetail } from '@/features/equipment/utils/product'
import { useUI } from '@/hooks/useUI'
import { Clock, Hash, MapPin, Package, Tag, User } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { TransferDetail } from '../../types/transferRequest'

export function TransferInfo({ transfer }: { transfer: TransferDetail }) {
  const { t } = useTranslation()
  const { transferStatuses, getEnumLabel } = useUI()
  const statusLabel = getEnumLabel(transferStatuses, transfer.status, transfer.status)

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-border/30 bg-secondary/20 p-3">
      <InfoRow
        icon={Package}
        label={t('common.equipment')}
        value={getProductDetail(transfer.product?.name, transfer.product?.categoryName) || '-'}
      />
      <InfoRow
        icon={Tag}
        label={t('requests.model')}
        value={getProductDetail(transfer.product?.brand, transfer.product?.model) || '-'}
      />
      <InfoRow icon={Hash} label={t('requests.quantity')} value={transfer.quantityRequested?.toString() || '-'} />
      {transfer.items?.length > 0 && (
        <InfoRow
          icon={Hash}
          label={t('equipment.item.serialNumber')}
          value={transfer.items?.map(item => item.serialNumber).join(', ') || '-'}
        />
      )}
      <InfoRow icon={User} label={t('requests.requester')} value={transfer.requester?.name || '-'} />
      <InfoRow
        icon={Package}
        label={t('requests.from')}
        value={transfer.sourceDepartment?.name || transfer.requesterDepartment?.name || '-'}
      />

      <InfoRow icon={MapPin} label={t('requests.to')} value={transfer.targetDepartment?.name || '-'} />
      <InfoRow icon={Clock} label={t('common.status')} value={statusLabel} />
      <p className="text-xs text-muted-foreground">
        {t('requests.reason')}: {transfer.reason || '-'}
      </p>
    </div>
  )
}

function InfoRow({ icon: Icon, label, value }: { icon: typeof Package; label: string; value: string }) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <Icon className="size-3 shrink-0 text-muted-foreground" />
      <span className="shrink-0 text-muted-foreground">{label}:</span>
      <span className="min-w-0 break-words font-medium text-foreground">{value}</span>
    </div>
  )
}
